"use client";
import React, { useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  Link,
} from "@react-pdf/renderer";
import companyLogo from "../../../../assets/images/agriGoatLogoImg.png";
import { ToWords } from "to-words";
import qrCode from "../../../../assets/images/qrcode.png";
import upiLogo from "../../../../assets/images/upiLogo.png";
import signImage from "../../../../assets/images/sign.png";
import { getObjectFromArrayOfObjects } from "../../../../utils/common/CommonFunctions";
// import {
//   formatDateToDisplay,
//   formatDateToDisplayEM,
//   formatDateToISO,
//   getObjectFromArray,
//   getTotalPrice,
// } from "@/src/utils/common/commonFunctions";
// Register font
// Font.register({ family: 'Roboto', src: source });

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF ",
    width: "100%",
    height: "100%",

    justifyContent: "center",
    alignItems: "center",
  },
  // wrapper: {
  //   width: "273px",
  //   height: "396px",
  //   border: "3px solid black",
  //   borderRadius: "12px",
  // },
  wrapper: {
    backgroundColor: "#fff",
    width: "100%",
    height: "100%",
    padding: "40px",
  },
  topWrapper: { flexDirection: "row" },
  topLeft: {
    alignSelf: "flex-end",
    textAlign: "right",
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: 5,
    color: "#848484",
    width: "50%",
    // backgroundColor: "black",
  },
  companyName: {
    fontSize: 14,
    fontWeight: "800",
    padding: "2px 0",
  },
  address: { fontSize: 10, fontWeight: "400", padding: "2px 0" },
  info: { fontSize: 10, fontWeight: "400", marginTop: 2, padding: "4px 0" },
  logoWrapper: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    marginVertical: 5,
    // backgroundColor: "black",
    width: "50%",
  },
  logo: { width: 63, height: 63 },
  logoText: {
    fontSize: 16,
    fontWeight: 700,
    marginHorizontal: "4px",
    color: "",
  },
  invoiceTitle: {
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginVertical: 10,
    color: "green",
  },
  section: {
    flexDirection: "row",
    marginVertical: 20,
    justifyContent: "space-between",
  },
  col: { flex: 1, paddingHorizontal: 5 },
  sectionTitle: { fontSize: 8, fontWeight: "800", marginBottom: 4 },
  text: {
    fontSize: 8,
    fontWeight: "400",
    margin: "4px 0",
    // backgroundColor: "black",
  },
  textBold: { fontSize: 11, fontWeight: "bold" },
  tableRow: { flexDirection: "row", borderBottomWidth: 1, borderColor: "#ccc" },
  subTotalConatiner: { flexDirection: "row" },
  invoice: { width: "80%" },
  invoiceWrapper: { paddingTop: "10px" },
  tableHeader: { backgroundColor: "#068708", padding: "6px 0" },
  cell: { padding: 4, fontSize: 8, fontWeight: "800" },
  cellSmall: { flex: 1 },
  cellMedium: { flex: 2 },
  words: { fontSize: 11, marginVertical: 5, fontWeight: "800" },
  summary: {
    // marginVertical: 10,
    // backgroundColor: "black",
    padding: "10px 0",
    width: "30%",
    alignContent: "flex-end",
  },
  summaryWrapper: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: "4px 0",
  },
  summarytext: {
    fontSize: 8,
    textAlign: "right",
    justifyContent: "space-between",
    fontWeight: "400",
    margin: "2px 2px",
    // width: "50%",
    // backgroundColor: "black",
  },
  summarytotal: {
    height: "25px",
    textAlign: "right",
    fontSize: "9",
    fontWeight: "600",
    backgroundColor: "#068708",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#fff",
    padding: "3px",
  },
  total: { fontWeight: "bold", fontSize: 13, color: "green" },
  qrSection: {
    flexDirection: "column",
    // alignItems: "center",
    marginTop: 40,
  },
  sectionWrapper: { flexDirection: "row" },
  sectionWrpper: { flexDirection: "row" },
  upi: { width: 38, height: 16 },
  qr: { width: 80, height: 80, marginRight: 5 },
  signatureWrapper: { marginTop: 10 },
  signatureLabel: { fontSize: 8, fontWeight: 400 },
  signImage: { width: 119, height: 40 },
});

// Create Document Component
export const InvoiceCartBundle = ({ orderData, qrImage, states, products }) => {
  const toWords = new ToWords({
    localeCode: "en-IN", // ✅ for Indian system (Lakhs/Crores)
  });

  console.log("orderData invoice", orderData);
  console.log("states", states);

  const formatDate = (str) => {
    const date = new Date(str);
    // extract parts
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const year = date.getFullYear();

    // format MM-DD-YYYY
    const formatted = `${month}-${day}-${year}`;
    return formatted;
  };

  const getProduct = (id) => {
    // console.log("products",products)
    const product = getObjectFromArrayOfObjects(products, "id", id);
    // console.log("pro",product)
    return product;
  };

  // console.log(numberToCurrencyWords(294990.5));
  // "Two Hundred Ninety Four Thousand Nine Hundred Ninety Rupees and Fifty Paise Only"

  const getTotal = () => {
    const totalSubTotal = orderData?.orders?.reduce(
      (acc, order) => acc + (order.subTotal || 0),
      0
    );

    return totalSubTotal?.toFixed(2);
  };

  const calculateTotalGST = (orders, products) => {
    return orders.reduce((total, order) => {
      const product = getObjectFromArrayOfObjects(
        products,
        "id",
        order?.productId
      );
      if (!product) return total;
      return total + (order.subTotal * product.gst) / 100;
    }, 0);
  };

  console.log(
    "state",
    getObjectFromArrayOfObjects(states, "id", orderData?.deliveryAddress?.state)
      ?.name?.replace(/\s+/g, "")
      .toLowerCase()
  );

  return (
    <Document>
      <Page size={"A4"} style={styles.page}>
        <View style={styles.wrapper}>
          {/* Header */}{" "}
          <Text style={styles.topLeft}>ORIGINAL FOR RECIPIENT</Text>
          <View style={styles.topWrapper}>
            <View style={styles.topLeftWrapper}>
              <Text style={styles.companyName}>Kriha Commerce</Text>
              <Text style={styles.address}>
                No.157/3B Karuppur, Ettaiyapuram, Thoothukudi District
              </Text>
              <Text style={styles.info}>Phone no : +919485987678</Text>
              <Text style={styles.info}>Email : support@kriha.in</Text>
              <Text style={styles.info}>GSTIN : 22AAKFE2321M1XD</Text>
              <Text style={styles.info}>State : 33 - Tamil Nadu</Text>
            </View>

            {/* Logo */}
            <View style={styles.logoWrapper}>
              <Image
                source={companyLogo} // Place your invoice logo here
                style={styles.logo}
                resizeMode="contain"
              />
              <Text style={styles.logoText}>Kriha Commerce</Text>
            </View>
          </View>
          <Text
            style={{
              borderBottomWidth: 1,
              borderColor: "#068708",
              marginVertical: 10,
            }}
          ></Text>
          {/* Invoice Title */}
          <Text style={styles.invoiceTitle}>Tax Invoice</Text>
          {/* Bill & Transport Details */}
          <View style={styles.section}>
            <View style={styles.col}>
              <Text style={styles.sectionTitle}>Bill To</Text>
              <Text style={styles.sectionTitle}>
                {orderData?.deliveryAddress?.name}
              </Text>
              <Text style={styles.text}>
                {orderData?.deliveryAddress?.addressLine1}
              </Text>
              <Text style={styles.text}>
                {orderData?.deliveryAddress?.addressLine2}
              </Text>
              <Text style={styles.text}>
                {orderData?.deliveryAddress?.city},
                {
                  getObjectFromArrayOfObjects(
                    states,
                    "id",
                    orderData?.deliveryAddress?.state
                  )?.name
                }
                - {orderData?.deliveryAddress?.postalCode}
              </Text>
              {/* <Text style={styles.text}>
                {orderData?.deliveryAddress?.state}
              </Text> */}
            </View>
            {/* <View style={styles.col}>
              <Text style={styles.sectionTitle}>Transportation Details</Text>
              <Text style={styles.text}>Transport Name:</Text>
              <Text style={styles.text}>Vehicle Number:</Text>
              <Text style={styles.text}>Delivery Date:</Text>
              <Text style={styles.text}>Delivery Location:</Text>
            </View> */}
            <View style={styles.col}>
              <Text style={styles.sectionTitle}>Invoice Details</Text>
              <Text style={styles.text}>
                Invoice No: {orderData?.invoiceNumber}
              </Text>
              <Text style={styles.text}>
                Date: {formatDate(orderData?.invoicedate)}
              </Text>
              {/* <Text style={styles.text}>
                Place of supply: {orderData?.deliveryAddress?.state}
              </Text> */}
            </View>
          </View>
          {/* Table Header */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text
              style={[
                styles.cell,
                styles.cellMedium,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              Item name
            </Text>
            <Text
              style={[
                styles.cell,
                styles.cellMedium,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              HSN/SAC
            </Text>
            <Text
              style={[
                styles.cell,
                styles.cellSmall,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              Quantity
            </Text>
            <Text
              style={[
                styles.cell,
                styles.cellSmall,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              Unit Price
            </Text>
            {/* <Text
              style={[
                styles.cell,
                styles.cellMedium,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              Price/Unit
            </Text> */}
            <Text
              style={[
                styles.cell,
                styles.cellMedium,
                { fontSize: 9, fontWeight: 600, color: "white" },
              ]}
            >
              Amount
            </Text>
          </View>
          {/* Table Row */}
          {orderData?.orders?.map((item) => (
            <View style={styles.tableRow}>
              <Text style={[styles.cell, styles.cellMedium]}>
                {getProduct(item?.productId)?.name}
              </Text>

              <Text style={[styles.cell, styles.cellMedium]}>
                {getProduct(item?.productId)?.hsnCode}
              </Text>

              <Text style={[styles.cell, styles.cellSmall]}>
                {item?.quantity}
              </Text>

              <Text style={[styles.cell, styles.cellSmall]}>
                {item?.subTotal / item?.quantity}
              </Text>

              <Text style={[styles.cell, styles.cellMedium]}>
                {item?.subTotal}
              </Text>
            </View>
          ))}
          {/* Total Row */}
          <View style={styles.tableRow}>
            <Text style={[styles.cell, styles.cellSmall]}></Text>
            <Text style={[styles.cell, styles.cellMedium]}>Total</Text>
            <Text style={[styles.cell, styles.cellSmall]}></Text>
            <Text style={[styles.cell, styles.cellSmall]}></Text>
            <Text style={[styles.cell, styles.cellSmall]}></Text>
            <Text style={[styles.cell, styles.cellMedium]}></Text>
            <Text style={[styles.cell, styles.cellMedium]}>
              Rs.
              {getTotal()}
            </Text>
          </View>
          <View style={styles?.subTotalConatiner}>
            {/* Invoice Words */}
            <View style={styles.invoice}>
              {/* <View style={styles.invoiceWrapper}>
                <Text style={styles.words}>Invoice Amount in Words</Text> */}
                {/* <Text style={styles.text}>
                  {toWords.convert(orderData?.orderDetails?.total)} only
                </Text> */}
              {/* </View> */}
              <View style={styles.invoiceWrapper}>
                {/* <Text style={styles.words}>Terms and Conditions</Text> */}
                <Link
                  src={`${process.env.NEXT_PUBLIC_FRONTEND_URL}termsAndConditions`}
                  style={styles.words}
                >
                  Terms and Conditions
                </Link>
                <Text style={styles.text}>
                  Thanks for doing business with us!
                </Text>
              </View>
            </View>

            {/* Summary */}
            <View style={styles.summary}>
              <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>Shipping Charges</Text>
                <Text style={styles.summarytext}>
                  Rs.{Math.ceil(orderData?.shippingCharges)}
                </Text>
              </View>
              <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>Sub Total</Text>
                <Text style={styles.summarytext}>
                  Rs.
                  {Number(getTotal()) +
                    Math.ceil(Number(orderData?.shippingCharges || 0))}
                </Text>
              </View>

              <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>CGST</Text>
                <Text style={styles.summarytext}>
                  Rs.
                  {(
                    calculateTotalGST(orderData?.orders, products) / 2
                  )?.toFixed(2)}
                </Text>
              </View>

              <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>
                  {getObjectFromArrayOfObjects(
                    states,
                    "id",
                    orderData?.deliveryAddress?.state
                  )
                    ?.name?.replace(/\s+/g, "")
                    .toLowerCase() === "tamilnadu" || "tn"
                    ? "SGST"
                    : "IGST"}
                  {/* {orderData?.deliveryAddress?.state === 1 ? "SGST" : "IGST"} */}
                </Text>
                <Text style={styles.summarytext}>
                  Rs.
                  {(
                    calculateTotalGST(orderData?.orders, products) / 2
                  )?.toFixed(2)}
                </Text>
              </View>

              <View style={styles.summarytotal}>
                <Text style={styles.summarytext}>Total</Text>
                <Text style={styles.summarytext}>
                  Rs.
                  {Math.ceil(
                    Number(getTotal()) +
                      Math.ceil(Number(orderData?.shippingCharges || 0)) +
                      Number(calculateTotalGST(orderData?.orders, products))
                  )}
                </Text>
              </View>
              {/* <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>Sub Total</Text>
                <Text style={styles.summarytext}> ₹2,94,990.50</Text>
              </View>

              <View style={styles.summaryWrapper}>
                <Text style={styles.summarytext}>Sub Total</Text>
                <Text style={styles.summarytext}> ₹2,94,990.50</Text>
              </View> */}
              <Text
                style={{
                  borderBottomWidth: 1,
                  borderColor: "#ADADAD",
                  marginVertical: 10,
                }}
              ></Text>
              {/* Signature */}
              <View style={styles.signatureWrapper}>
                <Text style={styles.signatureLabel}>
                  For : Kriha Commerce
                </Text>
                <Image src={signImage} style={styles.signImage} />
                <Text style={[styles.signatureLabel, { fontWeight: 800 }]}>
                  Authorized Signatory
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
